import { render } from "./EventosView.vue?vue&type=template&id=3bc80b5c&scoped=true"
import script from "./EventosView.vue?vue&type=script&lang=js"
export * from "./EventosView.vue?vue&type=script&lang=js"

import "./EventosView.vue?vue&type=style&index=0&id=3bc80b5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc80b5c"]])

export default __exports__